import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../AppProvider";
import { CustomerContext } from "../CustomerProvider";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/DeleteCustomerUser.css";
import { usersMicroserviceUrl } from "../../../../../microservices/users_microservice";
import { thingsBoardMicroserviceUrl } from "../../../../../microservices/thingsboard_microservice";

const DeleteCustomerUser = () =>{
    const {user,logout} = useContext(AppContext);
    const [deletingCustomerUserStatus,setDeletingCustomerUserStatus] = useState('');
    const{
        setReloadCustomerUsers,
        selectedTenantAdminProfile,
        setSelectedCustomerUser,
        selectedToDeleteCustomerUser,setSelectedToDeleteCustomerUser
    } = useContext(CustomerContext);
    const unregisterCustomerUser = async() =>{
        try{
            setDeletingCustomerUserStatus('unregistering');
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/customers/users/${selectedToDeleteCustomerUser?.iotProfileId}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setDeletingCustomerUserStatus('unregistered');
                return;
            }
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error('An error occurred when unregistering customer user from the IOT service',error);
        }
        setDeletingCustomerUserStatus('unregister-error');
    };
    const deleteCustomerUser = async() =>{
        try{
            setDeletingCustomerUserStatus('deleting');
            const url = `${usersMicroserviceUrl}/tenants/customer-users/${selectedToDeleteCustomerUser?.id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setDeletingCustomerUserStatus('deleted');
                setSelectedCustomerUser(null);
                setReloadCustomerUsers(true);
                return;
            }
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error('Unexpected error occurred when deleting customer administrator',error);
        }
        setDeletingCustomerUserStatus('delete-error');
    };
    useEffect(() =>{
        if(selectedToDeleteCustomerUser) document.title = 'Blink IOT | Delete customer user';
        else{
            document.title = 'Blink IOT | Customer users';
            setDeletingCustomerUserStatus('');
        }
    },[selectedToDeleteCustomerUser]);
    useEffect(() =>{
        if(deletingCustomerUserStatus === 'unregistered') deleteCustomerUser();
    },[deletingCustomerUserStatus]);
    useEffect(() =>{
        const handleEsc = (e) => {
            if(e.key === "Escape" && deletingCustomerUserStatus !== 'deleting' && deletingCustomerUserStatus !== 'unregistering') setSelectedToDeleteCustomerUser(null);
        };
        document.addEventListener("keydown",handleEsc);
        return () =>{
            document.removeEventListener("keydown",handleEsc);
        };
    },[selectedToDeleteCustomerUser,deletingCustomerUserStatus]);
    if(!selectedToDeleteCustomerUser) return null;
    return(
        <div className="tenant-administrator-delete-customer-user-parent-container">
            {deletingCustomerUserStatus === ''?
                (
                    <div className="tenant-administrator-delete-customer-user-container">
                        <h1>Delete customer user "{selectedToDeleteCustomerUser?.firstName} {selectedToDeleteCustomerUser?.lastName}"?</h1>
                        <p>Once deleted, this customer user cannot be recovered.</p>
                        <div className="tenant-administrator-delete-customer-user-buttons-container">
                            <button className="cancel-delete-button"
                                onClick={() => setSelectedToDeleteCustomerUser(null)}>
                                Don't delete
                            </button>
                            <button className="delete-button"
                                onClick={() => unregisterCustomerUser()}>
                                Delete customer user
                            </button>
                        </div>
                        <div className="tenant-administrator-delete-customer-user-escape-button-container"
                            onClick={() => setSelectedToDeleteCustomerUser(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):deletingCustomerUserStatus === 'unregistering'?
                (
                    <div className="tenant-administrator-unregistering-customer-user-container">
                        <div></div>
                        <p>Unregistering customer user from IOT service. Please wait...</p>
                    </div>
                ):deletingCustomerUserStatus === 'deleting'?
                (
                    <div className="tenant-administrator-deleting-customer-user-container">
                        <div></div>
                        <p>Deleting customer user. Please wait...</p>
                    </div>
                ):deletingCustomerUserStatus === 'deleted'?
                (
                    <div className="tenant-administrator-deleted-customer-user-container">
                        <h1>Customer user deleted</h1>
                        <p>Customer user "{selectedToDeleteCustomerUser?.firstName} {selectedToDeleteCustomerUser?.lastName}" deleted successfully</p>
                        <div className="tenant-administrator-deleted-customer-user-okay-button-container">
                            <button onClick={() =>{setSelectedToDeleteCustomerUser(null)}}>Okay</button>
                        </div>
                        <div className="tenant-administrator-deleted-customer-user-escape-button-container"
                            onClick={() => setSelectedToDeleteCustomerUser(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):deletingCustomerUserStatus === 'unregister-error'?
                (
                    <div className="tenant-administrator-customer-user-unregister-error-container">
                        <h1>Error</h1>
                        <p>Unexpected error occurred when unregistering customer user "{selectedToDeleteCustomerUser?.firstName} {selectedToDeleteCustomerUser?.lastName}" from IOT service.</p>
                        <div className="tenant-administrator-customer-user-unregister-error-okay-button-container">
                            <button onClick={() => setSelectedToDeleteCustomerUser(null)}>Okay</button>
                        </div>
                        <div className="tenant-administrator-customer-user-unregister-error-escape-button-container"
                            onClick={() => setSelectedToDeleteCustomerUser(null)}>
                                <button>&#10006;</button>
                                <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <div className="tenant-administrator-customer-user-delete-error-container">
                        <h1>Error</h1>
                        <p>An error occurred when deleting customer user "{selectedToDeleteCustomerUser?.firstName} {selectedToDeleteCustomerUser?.lastName}"</p>
                        <div className="tenant-administrator-customer-user-delete-error-okay-button-container">
                            <button onClick={() => setSelectedToDeleteCustomerUser(null)}>Okay</button>
                        </div>
                        <div className="tenant-administrator-customer-user-delete-error-escape-button-container"
                            onClick={() => setSelectedToDeleteCustomerUser(null)}>
                                <button>&#10006;</button>
                                <p>ESC</p>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
export default DeleteCustomerUser;